import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "stats-app" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "title is-3 mb-1" }, "GitHub Release Stats", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("This page summarizes stats for a GitHub repository. Feel free to ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://github.com/xarantolus/github-release-stats"
}, "check it out on GitHub", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(".")
const _hoisted_7 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "repo-input mt-4" }
const _hoisted_9 = {
  key: 1,
  class: "mt-5 title is-5 has-text-danger has-text-weight-bold"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode("No releases available for  ")
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_13 = { class: "mt-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h4", { class: "title is-4 pt-4" }, "Releases", -1)
const _hoisted_15 = {
  key: 3,
  class: "history"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h4", { class: "title is-4 pt-4" }, "History", -1)
const _hoisted_18 = ["href", "onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 4,
  class: "mt-4"
}
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Not sure what you're looking for? ")
const _hoisted_22 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_23 = {
  key: 5,
  class: "help"
}
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" If you want to link to releases without showing the input above, you can add the ")
const _hoisted_25 = /*#__PURE__*/_createElementVNode("code", null, "noform", -1)
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" URL parameter. ")
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" You can also ")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Copied!")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("create a badge")
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" for your README file. ")
const _hoisted_31 = {
  key: 6,
  class: "help"
}
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" to find stats for other repositories. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RepoInput = _resolveComponent("RepoInput")!
  const _component_ReleaseSummary = _resolveComponent("ReleaseSummary")!
  const _component_ReleaseCard = _resolveComponent("ReleaseCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.showForm())
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _hoisted_7))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_RepoInput, {
        disabled: !_ctx.showForm(),
        onRepoChange: _ctx.handleRepoChange,
        "username-suggestions": _ctx.usernameSuggestions(),
        onInterface: _cache[0] || (_cache[0] = (i) => _ctx.repoInterface = i)
      }, null, 8, ["disabled", "onRepoChange", "username-suggestions"])
    ]),
    (_ctx.releases && _ctx.releases.length === 0)
      ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("a", {
            href: 'https://github.com/' + encodeURI(_ctx.userName!) + '/' + encodeURI(_ctx.repoName!),
            target: "_blank"
          }, _toDisplayString(_ctx.userName) + "/" + _toDisplayString(_ctx.repoName), 9, _hoisted_11),
          _hoisted_12
        ]))
      : (_ctx.releases && _ctx.releases.length > 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createVNode(_component_ReleaseSummary, {
              class: "mt-4",
              releases: _ctx.releases!,
              "user-name": _ctx.userName!,
              "repo-name": _ctx.repoName!
            }, null, 8, ["releases", "user-name", "repo-name"]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.releases ?? []), (release) => {
                return (_openBlock(), _createBlock(_component_ReleaseCard, {
                  key: release.id,
                  release: release
                }, null, 8, ["release"]))
              }), 128))
            ])
          ], 64))
        : (_ctx.showForm() && _ctx.history.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _hoisted_16,
              _hoisted_17,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.history, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.userName + '/' + item.repoName,
                  class: "buttons field has-addons mb-0"
                }, [
                  _createElementVNode("a", {
                    href: _ctx.historyURL(item),
                    onClick: _withModifiers(($event: any) => (_ctx.repoInterface?.loadRepo(item.userName, item.repoName)), ["prevent"]),
                    class: "control button is-expanded is-info is-outlined has-text-weight-bold"
                  }, _toDisplayString(item.userName) + "/" + _toDisplayString(item.repoName), 9, _hoisted_18),
                  _createElementVNode("button", {
                    class: "control button is-danger delete-button",
                    onClick: _withModifiers(($event: any) => (_ctx.removeHistoryItem(item)), ["prevent"])
                  }, " X ", 8, _hoisted_19)
                ]))
              }), 128)),
              _createElementVNode("button", {
                class: "button is-expanded is-danger mt-4 delete-button",
                onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.removeAllHistory && _ctx.removeAllHistory(...args)), ["prevent"]))
              }, "Clear repository history")
            ]))
          : (_ctx.showForm())
            ? (_openBlock(), _createElementBlock("p", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("a", {
                  href: "/?user=xarantolus&repo=filtrite",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.repoInterface?.loadRepo('xarantolus', 'filtrite')), ["prevent"]))
                }, "Click here to try one of my repos"),
                _hoisted_22
              ]))
            : _createCommentVNode("", true),
    (_ctx.showForm())
      ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
          _hoisted_24,
          _hoisted_25,
          _hoisted_26,
          (_ctx.repoName && _ctx.userName)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_27,
                _createElementVNode("span", {
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.copyBadge()), ["prevent"])),
                  class: "has-text-weight-bold is-underlined is-clickable"
                }, [
                  (_ctx.copying)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_28
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _hoisted_29
                      ], 64))
                ]),
                _hoisted_30
              ], 64))
            : _createCommentVNode("", true)
        ]))
      : (_ctx.repoName && _ctx.userName)
        ? (_openBlock(), _createElementBlock("span", _hoisted_31, [
            _createTextVNode(" The current page shows stats for " + _toDisplayString(_ctx.userName) + "/" + _toDisplayString(_ctx.repoName) + ", visit the ", 1),
            _createElementVNode("a", {
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.repoInterface?.reset()), ["prevent"])),
              href: "/"
            }, "main page"),
            _hoisted_32
          ]))
        : _createCommentVNode("", true)
  ]))
}